var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin_svg__a)",
    fill: "#89969A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.994 23v-.001H23v-8.436c0-4.126-.888-7.305-5.713-7.305-2.319 0-3.875 1.273-4.51 2.48h-.068V7.642H8.135V23h4.763v-7.604c0-2.002.38-3.938 2.859-3.938 2.443 0 2.48 2.285 2.48 4.067V23h4.757ZM.38 7.645h4.768V23H.38V7.645ZM2.762 0A2.763 2.763 0 0 0 0 2.762C0 4.287 1.237 5.55 2.762 5.55s2.762-1.263 2.762-2.788A2.764 2.764 0 0 0 2.762 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23v23H0z"
  })))));
};
export default SvgLinkedin;